export default __webpack_public_path__ + "static/media/finishing-1.a462405a.webp";